if (!customElements.get("read-more")) {
	customElements.define(
		"read-more",
		class ReadMore extends HTMLElement {
			connectedCallback() {
				this.content = this.querySelector(".read-more__content");
				this.button = this.querySelector(".read-more__toggle");
				if (!this.content || !this.button) return;

				this.expanded = false;
				this.button.addEventListener("click", this.toggle.bind(this));
				this.content.addEventListener("transitionend", (event) => {
					// Once fully open, drop the fixed height so content can reflow (resize, fonts).
					if (event.propertyName === "max-height" && this.expanded)
						this.content.style.maxHeight = "none";
				});

				this.update();
				this.resizeObserver = new ResizeObserver(() => {
					if (!this.expanded) this.update();
				});
				this.resizeObserver.observe(this);
			}

			disconnectedCallback() {
				if (this.resizeObserver) this.resizeObserver.disconnect();
			}

			// Height of the first N lines, based on the line-height of the first text element.
			getCollapsedHeight() {
				const lines = parseInt(this.dataset.lines, 10) || 4;
				const textElement = this.content.firstElementChild || this.content;
				const style = getComputedStyle(textElement);
				let lineHeight = parseFloat(style.lineHeight);
				if (isNaN(lineHeight)) lineHeight = parseFloat(style.fontSize) * 1.5;
				return Math.ceil(lineHeight * lines);
			}

			// Only clamp (and show the button) when the text is actually longer than N lines.
			update() {
				this.collapsedHeight = this.getCollapsedHeight();
				const needsClamp = this.content.scrollHeight > this.collapsedHeight + 2;

				this.button.hidden = !needsClamp;
				this.classList.toggle("read-more--clamped", needsClamp);
				this.content.style.maxHeight = needsClamp
					? `${this.collapsedHeight}px`
					: "none";
			}

			toggle() {
				this.expanded = !this.expanded;
				this.classList.toggle("read-more--expanded", this.expanded);
				this.button.setAttribute("aria-expanded", this.expanded);

				if (this.expanded) {
					this.content.style.maxHeight = window.matchMedia(
						"(prefers-reduced-motion: reduce)"
					).matches
						? "none"
						: `${this.content.scrollHeight}px`;
				} else {
					// From "none" back to a pixel value first, so the closing transition can run.
					this.content.style.maxHeight = `${this.content.scrollHeight}px`;
					this.content.offsetHeight;
					this.content.style.maxHeight = `${this.collapsedHeight}px`;
				}
			}
		}
	);
}
